import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Helmet from 'react-helmet';
import { useTheme } from '@emotion/react';
import { BreadcrumbContainer, LastBreadcrumb, Breadcrumb } from './Breadcrumbs.styles.js';
import { Section } from './BreadcrumbsContainer.styles.js';
import { checkDictionary } from './utils.js';
import { BREADCRUMB } from '../../utils/dataTrackingValues.js';

var _excluded = ["crumbs", "path", "siteURL", "CustomLink", "removeTrailingSlashes"];
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _components$Breadcrum;
  var _ref$crumbs = _ref.crumbs,
    crumbs = _ref$crumbs === void 0 ? [] : _ref$crumbs,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '' : _ref$path,
    _ref$siteURL = _ref.siteURL,
    siteURL = _ref$siteURL === void 0 ? '' : _ref$siteURL,
    _ref$CustomLink = _ref.CustomLink,
    CustomLink = _ref$CustomLink === void 0 ? null : _ref$CustomLink,
    _ref$removeTrailingSl = _ref.removeTrailingSlashes,
    removeTrailingSlashes = _ref$removeTrailingSl === void 0 ? false : _ref$removeTrailingSl,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    components = _useTheme.components;
  var crumbList = crumbs || [];
  // Creates crumbs based off the page path if none have been provided
  if (crumbList.length <= 0 && path !== '/') {
    crumbList = path.split('/').map(function (node, index) {
      var currentPath = index === 0 ? '/' : "".concat(path.substring(0, path.indexOf(node))).concat(node);
      var shortName = index === 0 ? 'Home' : checkDictionary(node.replace(/-/g, ' '));
      if (!removeTrailingSlashes && index !== 0) {
        currentPath += '/';
      }
      return {
        shortName: shortName,
        path: currentPath
      };
    });
  }
  return crumbList.length > 0 && /*#__PURE__*/React.createElement(Section, {
    backgroundColor: components === null || components === void 0 || (_components$Breadcrum = components.Breadcrumbs) === null || _components$Breadcrum === void 0 ? void 0 : _components$Breadcrum.backgroundColor
  }, /*#__PURE__*/React.createElement(BreadcrumbContainer, _extends({
    className: "leshen-breadcrumbs"
  }, props), /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, "\n          {\n            \"@context\":\"https://schema.org\",\n            \"@type\": \"BreadcrumbList\",\n              \"itemListElement\": [\n              ".concat(crumbList.map(function (crumb, i) {
    return "\n                    {\n                      \"@type\": \"ListItem\",\n                      \"position\": \"".concat(i + 1, "\",\n                      \"item\": {\n                        \"@id\": \"").concat(siteURL).concat(crumbList[i].path, "\",\n                        \"name\": \"").concat(crumb.shortName, "\"\n                      }\n                    }\n                  ");
  }), "\n            ]\n          }\n        "))), crumbList.map(function (_ref2, index) {
    var shortName = _ref2.shortName,
      crumbPath = _ref2.path;
    return index === crumbList.length - 1 ? /*#__PURE__*/React.createElement(LastBreadcrumb, {
      className: "leshen-breadcrumb-last",
      key: shortName
    }, shortName) : /*#__PURE__*/React.createElement(Breadcrumb, {
      className: "leshen-breadcrumb",
      key: shortName,
      CustomLink: CustomLink,
      to: crumbPath,
      "data-tracking": BREADCRUMB.LINK
    }, shortName);
  })));
};
var Breadcrumbs$1 = Breadcrumbs;

export { Breadcrumbs$1 as default };
//# sourceMappingURL=index.js.map
